import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="bg-white shadow-sm sticky-top">
      <div className="container py-2">
        <div className="d-flex align-items-center justify-content-between gap-4 flex-wrap">

          {/* Logo */}
          <div className="d-flex align-items-center" style={{ padding: '5px 10px', borderRadius: '5px' }}>
            <Link to="/">
              <img
                src="assets/img/logo.png"
                alt="Avighna"
                style={{ height: '45px' }}
              />
            </Link>
          </div>

          {/* Navigation */}
          <nav className="d-none d-xl-block">
            <ul className="nav gap-2">
              <li className="nav-item">
                <Link className="nav-link" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">About Us</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/services">Services</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/Industries">Industries</Link>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="avighna-career.php">Careers</a>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">Contact Us</Link>
              </li>
            </ul>
          </nav>

          {/* Search + Get In Touch */}
          <div className="d-none d-xl-flex align-items-center gap-3">
            <button className="btn btn-outline-primary text-dark" style={{ fontSize: '1.25rem' }}>
              <i className="bi bi-search"></i>
            </button>
            <Link to="/contact" className="btn btn-primary">
              Get In Touch <i className="fa fa-arrow-right ms-2"></i>
            </Link>
          </div>

          {/* Mobile Toggle (visible on small screens) */}
          <div className="d-block d-xl-none">
            <button className="btn btn-outline-dark">
              <i className="fas fa-bars"></i>
            </button>
          </div>

        </div>
      </div>
    </header>
  );
};

export default Header;
